<div class="history-container">
  @if (isLoading()) {
    <div class="loading-overlay">
      <mat-progress-spinner mode="indeterminate" diameter="40" />
    </div>
  }
  @if (!isLoading() && formattedHistory().length) {
    <table class="history-table">
      <thead class="history-header">
        <tr class="history-header-row">
          <th class="history-header-cell">{{ 'orders.history.date' | translate }}</th>
          <th class="history-header-cell">{{ 'orders.history.status' | translate }}</th>
          <th class="history-header-cell">{{ 'orders.history.creator' | translate }}</th>
          <th class="history-header-cell">{{ 'orders.history.comment' | translate }}</th>
        </tr>
      </thead>
      <tbody class="history-body">
        @for (log of formattedHistory(); track log.id || $index) {
          <tr class="history-row">
            <td class="date-cell">{{ log.updatedAt | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
            <td class="history-cell">
              <span class="status-badge" [class]="log.statusClass">
                {{ log.statusLabel }}
              </span>
            </td>
            <td class="history-cell creator-cell">{{ log.updatedBy }}</td>
            <td class="history-cell comment-cell">{{ log.comment || '-' }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
  @if (!isLoading() && !errorMessage() && !formattedHistory().length) {
    <div class="no-records">
      <p>{{ 'orders.history.noRecords' | translate }}</p>
    </div>
  }

  @if (!isLoading() && errorMessage()) {
    <div class="no-records">
      <p class="error-message">{{ 'orders.history.noNetworkConnection' | translate }}</p>
    </div>
  }
</div>
